var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileFooterPattern = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 261,
    viewBox: "0 0 375 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_389_26773)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.242 5.70508L359.607 19.3996C343.972 33.0941 312.702 60.4832 281.432 60.4832C250.161 60.4832 218.891 33.0941 187.621 26.2469C156.351 19.3996 125.081 33.0941 93.8105 36.5178C62.5403 39.9414 31.2702 33.0941 15.6351 29.6705L0 26.2469V170.039H15.6351C31.2702 170.039 62.5403 170.039 93.8105 170.039C125.081 170.039 156.351 170.039 187.621 170.039C218.891 170.039 250.161 170.039 281.432 170.039C312.702 170.039 343.972 170.039 359.607 170.039H375.242V5.70508Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.032 90.5114L410.269 83.3738C398.15 76.2361 374.624 61.9607 350.742 52.4438C326.86 42.9269 303.335 38.1685 279.452 40.5477C255.57 42.9269 232.045 52.4438 208.163 59.5815C184.281 66.7192 160.755 71.4776 136.873 71.4776C112.991 71.4776 89.4656 66.7192 65.5836 61.9607C41.7016 57.2023 18.176 52.4438 6.05676 50.0646L-5.70599 47.6854V143.792H6.05676C18.176 143.792 41.7016 143.792 65.5836 143.792C89.4656 143.792 112.991 143.792 136.873 143.792C160.755 143.792 184.281 143.792 208.163 143.792C232.045 143.792 255.57 143.792 279.452 143.792C303.335 143.792 326.86 143.792 350.742 143.792C374.624 143.792 398.15 143.792 410.269 143.792H422.032V90.5114Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-123.821 100.831L-111.761 97.4023C-100.116 93.9732 -76.4103 87.1148 -52.7048 76.8273C-28.5834 66.5398 -4.87784 52.8231 18.8277 49.394C42.5332 45.9648 66.2387 52.8231 89.9442 63.1107C113.65 73.3982 137.771 87.1148 161.477 97.4023C185.182 107.69 208.888 114.548 232.593 114.548C256.299 114.548 280.004 107.69 304.126 104.261C327.831 100.831 351.537 100.831 363.181 100.831H375.242V203.707H363.181C351.537 203.707 327.831 203.707 304.126 203.707C280.004 203.707 256.299 203.707 232.593 203.707C208.888 203.707 185.182 203.707 161.477 203.707C137.771 203.707 113.65 203.707 89.9442 203.707C66.2387 203.707 42.5332 203.707 18.8277 203.707C-4.87784 203.707 -28.5834 203.707 -52.7048 203.707C-76.4103 203.707 -100.116 203.707 -111.761 203.707H-123.821V100.831Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-232.236 82.166H-206.925C-181.613 82.166 -130.99 82.166 -80.3667 106.131C-29.7435 130.097 20.8797 178.028 71.5029 191.722C122.126 205.417 172.749 184.875 223.372 160.91C273.996 136.944 324.619 109.555 349.93 95.8605L375.242 82.166V267.042H349.93C324.619 267.042 273.996 267.042 223.372 267.042C172.749 267.042 122.126 267.042 71.5029 267.042C20.8797 267.042 -29.7435 267.042 -80.3667 267.042C-130.99 267.042 -181.613 267.042 -206.925 267.042H-232.236V82.166Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_26773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 261,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileFooterPattern);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile-footer-pattern.b7fdd49a7909a7cd8f5f2e367b52150c.svg";